<!-- Do not change this file. -->

<template>
  <div>
    <div
      class="alert border-3 fw-bold text-center fs-3"
      :class="{
        'alert-success': session === 'Valid',
        'alert-danger': session !== 'Valid'
      }"
    >
      SESSION {{ session }}
    </div>
  </div>
</template>

<script>
/* Do not change this file. */

import AuthAPI from "@/helpers/AuthAPI";

export default {
  name: "DebugAuth",
  mixins: [AuthAPI],
  data() {
    return {
      session: null
    };
  },
  methods: {
    check() {
      console.log("checking...");
      this.readSession((e) => {
        console.log("SESSION", e);
        this.session = e;
        if (this.session === "Valid") {
          setTimeout(() => {
            this.check();
          }, 10000);
        } else {
          this.$emit("session-expired");
        }
      });
    }
  },
  mounted() {
    this.check();
  }
};
</script>
